import { inject, Injectable } from '@angular/core';
import { SettingsStoreDispatcher } from '@common/dispatchers/settings.dispatcher';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable({ providedIn: 'root' })
export class ChangeLanguageService {
  private readonly localizeRouterService = inject(LocalizeRouterService);
  private readonly settingsDispatcher = inject(SettingsStoreDispatcher);
  private readonly marketplaceStoreSelector = inject(MarketplaceStoreSelector);

  /**
   * It will not reload the page (and update MP and shops translations), but it will change the language in the store and update the router.
   */
  public changeLanguage(lang: string): void {
    this.settingsDispatcher.updateAppLocale(lang);
    this.localizeRouterService.changeLanguage(lang, {
      replaceUrl: true,
    });
  }

  public resetLanguage(): string {
    const locale = this.marketplaceStoreSelector.marketplace.default_locale?.locale ?? 'fr';
    this.settingsDispatcher.updateAppLocale(locale);
    this.localizeRouterService.changeLanguage(locale, {
      replaceUrl: true,
    });
    return locale;
  }
}
